import React from 'react';
import './Gifting_step_2.css';

import {Helmet} from "react-helmet";
import MasterButton from '../../../general_components/MasterButton/MasterButton.js';

import calculator from '../../../../utils/calculator.js';
import dates from '../../../../utils/dates';

import image_1 from '../../../../images/illustrations/growing_gift.png';
import Dropdown_input from '../../../general_components/Dropdown_input/Dropdown_input';

import config from '../../../../utils/config.js'
import amplitude from 'amplitude-js';
amplitude.getInstance().init(config.amp_key);

class Gifting_step_2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Gift_delivery_time: '',
            time_options: [
                {id: 8001, title: '08:00 AM'},
                {id: 8301, title: '08:30 AM'},
                {id: 9001, title: '09:00 AM'},
                {id: 9301, title: '09:30 AM'},
                {id: 10001, title: '10:00 AM'},

                {id: 10301, title: '10:30 AM'},
                {id: 11001, title: '11:00 AM'},
                {id: 11301, title: '11:30 AM'},
                {id: 12002, title: '12:00 PM'},
                {id: 12302, title: '12:30 PM'},

                {id: 1002, title: '01:00 PM'},
                {id: 1302, title: '01:30 PM'},
                {id: 2002, title: '02:00 PM'},
                {id: 2302, title: '02:30 PM'},
                {id: 3002, title: '03:00 PM'},

                {id: 3302, title: '03:30 PM'},
                {id: 4002, title: '04:00 PM'},
                {id: 4302, title: '04:30 PM'},
                {id: 5002, title: '05:00 PM'},
                {id: 5302, title: '05:30 PM'},
                
                {id: 6002, title: '06:00 PM'},
                {id: 6302, title: '06:30 PM'},
                {id: 7002, title: '07:00 PM'},
                {id: 7302, title: '07:30 PM'},
                {id: 8002, title: '08:00 PM'},

                {id: 8302, title: '08:30 PM'},
                {id: 9002, title: '09:00 PM'},
                {id: 9302, title: '09:30 PM'},
                {id: 10002, title: '10:00 PM'},
                {id: 10302, title: '10:30 PM'},

                {id: 11002, title: '11:00 PM'},
                {id: 11302, title: '11:30 PM'},
                {id: 12001, title: '12:00 AM'},
                {id: 12301, title: '12:30 AM'},
                {id: 1001, title: '01:00 AM'},

                {id: 1301, title: '01:30 AM'},
                {id: 2001, title: '02:00 AM'},
                {id: 2301, title: '02:30 AM'},
                {id: 3001, title: '03:00 AM'},
                {id: 3301, title: '03:30 AM'},

                {id: 4001, title: '04:00 AM'},
                {id: 4301, title: '04:30 AM'},
                {id: 5001, title: '05:00 AM'},
                {id: 5301, title: '05:30 AM'},
                {id: 6001, title: '06:00 AM'},

                {id: 6301, title: '06:30 AM'},
                {id: 7001, title: '07:00 AM'},
                {id: 7301, title: '07:30 AM'},
            ],
            no_options: false
        }


        this.dateChange = this.dateChange.bind(this);
        this.getTodaysTimes = this.getTodaysTimes.bind(this);
    }

    componentDidMount(){
        if (dates.current_time() >= '23:30:00') {
            this.setState({no_options: true})
        } else {
            this.setState({no_options: false})
        }
    }

    dateChange(event) {
        this.props.handleChange(event);
    }

    getTodaysTimes(){
        console.log('getting todays times')
        console.log('current time:', dates.current_time())
        // when selecting today, focus the times list to only future times 
        let todaysTimes;
        // slice the times list based on the time of day, starting at 8 AM and putting midnight - 8 am in the last options
        
        if (dates.current_time() >= '08:00:00' && dates.current_time() < '23:30:00') {
            let index = this.state.time_options.findIndex( item => 
                dates.militarizeTime(item.title) > dates.current_time())
            console.log('current times index:', index);
            todaysTimes = this.state.time_options.slice(index + 1, 32);
            /*
            if(this.props.Gift_delivery_time && !todaysTimes.includes(this.props.Gift_delivery_time)){
                this.props.handleHourSelection(todaysTimes[0])
            }
            */
            return todaysTimes;
        
        } else if (dates.current_time() < '08:00:00' && dates.current_time() > '07:30:00') {
            todaysTimes = this.state.time_options.slice(0, 32);
            return todaysTimes;

        } else if (dates.current_time() < '08:00:00') {
            let index = this.state.time_options.findIndex( item => 
                (dates.militarizeTime(item.title) > dates.current_time()) &&
                 dates.militarizeTime(item.title) < '08:00:00')
            
            todaysTimes = this.state.time_options.slice(index).concat(this.state.time_options.slice(0, 32));
            /*
            if(this.props.Gift_delivery_time && !todaysTimes.includes(this.props.Gift_delivery_time)){
                this.props.handleHourSelection(this.state.time_options.slice(index + 1)[0])
            }
            */
            return todaysTimes;
        }
    }


    render () {   
        if (this.props.currentStep !== 2) {
            return null;
        };
        return (
           <div>
               <Helmet>
                    <title>{`Give a Monetary Gift | Gift Details | Greatest Gift`}</title>
               </Helmet>
                <h2>Gift Details</h2>
        
                <form>
                    <p className='form_label'>Gift amount:</p>
                    
                    <div className='input_buttons_container amount_input_button_container'>
                        <p  onClick={() => {this.props.set_amount('$20'); amplitude.getInstance().logEvent('gifting: select gift amount', {'gift amount': '20'});}}
                            className={this.props.Gift_amount === '$20' ? 'input_button input_button_selected large_text amount_input_button' : 'input_button  large_text amount_input_button'}>
                                $20
                        </p>
                        <p  onClick={() => {this.props.set_amount('$50'); amplitude.getInstance().logEvent('gifting: select gift amount', {'gift amount': '50'});}}
                            className={this.props.Gift_amount === '$50' ? 'input_button input_button_selected large_text amount_input_button' : 'input_button  large_text amount_input_button'}>
                                $50
                        </p>
                        <p  onClick={() => {this.props.set_amount('$100'); amplitude.getInstance().logEvent('gifting: select gift amount', {'gift amount': '100'});}}
                            className={this.props.Gift_amount === '$100' ? 'input_button input_button_selected large_text amount_input_button' : 'input_button  large_text amount_input_button'}>
                                $100
                        </p>
                        <p  onClick={() => {this.props.set_amount('$180'); amplitude.getInstance().logEvent('gifting: select gift amount', {'gift amount': '180'});}}
                            className={this.props.Gift_amount === '$180' ? 'input_button input_button_selected large_text amount_input_button' : 'input_button  large_text amount_input_button'}>
                                $180
                        </p>
                        <p  onClick={() => {this.props.set_amount('$250'); amplitude.getInstance().logEvent('gifting: select gift amount', {'gift amount': '250'});}}
                            className={this.props.Gift_amount === '$250' ? 'input_button input_button_selected large_text amount_input_button' : 'input_button  large_text amount_input_button'}>
                                $250
                        </p>
                        {/*
                        <p  onClick={() => this.props.set_amount('$360')}
                            className={this.props.Gift_amount === '$360' ? 'input_button input_button_selected large_text amount_input_button' : 'input_button  large_text amount_input_button'}>
                                $360
                        </p>
                        */}
                    <input 
                        type='text' 
                        id='other_gift_amount' 
                        onChange={this.props.handleChange}
                        onBlur={this.props.handleDollarInput}
                        onClick={this.props.handleChange}
                        name='other_gift_amount' 
                        placeholder='Other' 
                        value={this.props.other_gift_amount}
                        autoComplete='off'
                        maxLength={this.props.other_gift_amount[0] === '$' ? 5 : 4}
                        className={ this.props.other_gift_amount && this.props.Gift_amount === this.props.other_gift_amount ? 'input_button input_button_selected large_text amount_input_button' : 'input_button  large_text amount_input_button'}
                        />

                    <input 
                        style={{display: 'none'}}
                        type='text' 
                        id='gift_amount' 
                        onChange={this.props.handleChange}
                        onBlur={this.props.handleDollarInput}
                        name='Gift_amount' 
                        placeholder='Value' 
                        value={this.props.Gift_amount}
                        autoFocus
                        autoComplete='off'
                        maxLength={this.props.Gift_amount[0] === '$' ? 5 : 4}
                        className={ this.props.Gift_amount ? 'input_button input_button_selected large_text amount_input_button' : 'input_button  large_text amount_input_button'}
                        />

                    </div>
                    
                    <p className='form_label'>Gift delivery date (EST):</p>
                    <input 
                        type='text' 
                        id='gift_delivery_date' 
                        name='Gift_delivery_date' 
                        onChange={this.props.handleDateChange}
                        value={this.props.Gift_delivery_date}
                        maxLength='10'
                        placeholder='MM / DD / YYYY'
                         />
                    
                    <div className='input_buttons_container'>
                        
                        <p  onClick={() => this.props.set_date(dates.today())}
                            className={this.props.Gift_delivery_date === dates.today() ? 'input_button input_button_selected small_text' : 'input_button  small_text'}>
                                Today
                        </p>

                        <p  onClick={() => this.props.set_date(dates.tomorrow())}
                            className={this.props.Gift_delivery_date === dates.tomorrow() ? 'input_button input_button_selected small_text' : 'input_button  small_text'}>
                                Tomorrow 
                        </p>
                        
                        <p  onClick={() => this.props.set_date(dates.nextWeek())}
                            className={this.props.Gift_delivery_date === dates.nextWeek() ? 'input_button input_button_selected small_text' : 'input_button  small_text'}>
                                {dates.dayOfWeek(dates.nextWeek())} {dates.nextWeek()}
                        </p>


                    </div>
                    
                    <p className='form_label'>Gift delivery time (EST):</p> 
                    <Dropdown_input
                        dd_name='gift_delivery_time'

                        header={this.state.no_options && this.props.Gift_delivery_date === dates.today() ? 'Please select a different date' : 'Select time' }
                        list={
                            !(this.props.Gift_delivery_date === dates.today()) ? 
                            this.state.time_options :
                            this.getTodaysTimes()
                            }
    
                        handleItemClick={this.props.handleHourSelection}
    
                        selected={this.props.Gift_delivery_time}
                        
                        highlight={false}
                        
                        lastItem={false}
                        active={this.state.no_options && this.props.Gift_delivery_date === dates.today() ? false : true}
                    />

                    <p className='tiny_text'>*Delivery times are based on Eastern Standard Time. Current EST: {dates.today()} {dates.current_time()}</p>

                </form>
                




                <div className='gifting_flow_image_container'>
                    <img src={image_1}/>
                <p>When invested tax free, your gift could grow into <span className='money'>${calculator.compound(this.props.Gift_amount, 18, 0.07)}</span> in 18 years</p>
                </div>

                <MasterButton 
                    buttonText={this.props.buttonText} 
                    handleButtonClick={this.props.handleButtonClick}
                    notSticky={true}
                />

                


           </div>
        );
    }
}

export default Gifting_step_2;

/*

                    <p className='form_label'>Gift delivery date:</p>
                    <input 
                        className='dropdown_input' 
                        id='gift_delivery_date' 
                        name='gift_delivery_date' 
                        onChange={this.props.handleChange}
                        value={this.props.Gift_delivery_date}
                        maxLength='10'
                        placeholder='MM / DD / YYYY'

                        list='gift_delivery_date_options'                    
                        autoComplete='off'
                        />
                    <datalist id='gift_delivery_date_options'>
                        <option value={dates.tomorrow()}>    Tomorrow</option>
                        <option value={dates.nextWeek()}>    Next Week</option>
                    </datalist>
*/